import { Link } from "react-router-dom";
import { Text } from "@mantine/core";
import styles from "./styles/Footer.module.css";

const explore = [
    { label: "Kategorier", to: "/kategori" },
    { label: "Topplistan", to: "/topplista" },
    { label: "Senast tillagda poddar", to: "/poddar" },
    { label: "Poddsamlingar", to: "/samling" },
];

const about = [
    { label: "Om HittaPodd", to: "/om" },
    { label: "Policy och cookies", to: "/policy" },
];

const YEAR = new Date().getFullYear();

export const Footer = () => {
    return (
        <footer className={styles.footer}>
            <div className={styles.inner}>
                <div className={styles.brand}>
                    <Text className={styles.brandName}>HittaPodd</Text>
                    <Text c="dimmed" size="sm">
                        Hitta din nästa podcast. Svenska poddar, topplistor och nya avsnitt varje dag.
                    </Text>
                </div>

                <nav aria-label="Utforska" className={styles.column}>
                    <Text className={styles.heading}>Utforska</Text>
                    <ul>
                        {explore.map((l) => (
                            <li key={l.to}>
                                <Link to={l.to}>{l.label}</Link>
                            </li>
                        ))}
                    </ul>
                </nav>

                <nav aria-label="Om oss" className={styles.column}>
                    <Text className={styles.heading}>Om oss</Text>
                    <ul>
                        {about.map((l) => (
                            <li key={l.to}>
                                <Link to={l.to}>{l.label}</Link>
                            </li>
                        ))}
                        <li>
                            <a href="mailto:hello@yetric.com">Kontakta oss</a>
                        </li>
                    </ul>
                </nav>
            </div>

            <div className={styles.legal}>
                <Text c="dimmed" size="xs">
                    © {YEAR}{" "}
                    <a href="https://yetric.se" rel="noopener noreferrer" target="_blank">
                        Yetric AB
                    </a>
                    . Alla poddar och omslagsbilder tillhör respektive utgivare.
                </Text>
            </div>
        </footer>
    );
};
